export default "__VITE_ASSET__C3AGt45d__"